import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Users } from 'lucide-react';
import { useAuthStore } from '../../store/authStore';
import { LoginForm } from '../../components/auth/LoginForm';

export default function ContactManagerLogin() {
  const [error, setError] = useState<string | null>(null);
  const login = useAuthStore((state) => state.login);
  const navigate = useNavigate();

  const handleLogin = async (email: string, password: string) => {
    try {
      await login(email, password);
      navigate('/contactmanager/home');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred during login. Please try again.');
    }
  };

  const handleForgotPassword = () => {
    // For now, we'll just show an alert. In a real application,
    // this would navigate to a password reset page or show a modal
    alert('Password reset functionality will be implemented soon.');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-white flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center space-x-2 mb-6">
            <Users className="w-10 h-10 text-blue-500" />
            <span className="text-3xl font-bold gradient-text">Contact Manager</span>
          </div>
          <h2 className="text-2xl font-bold text-gray-900">Welcome back</h2>
          <p className="text-gray-600 mt-2">Sign in to manage your contacts</p>
        </div>

        <LoginForm 
          onSubmit={handleLogin} 
          error={error}
          onForgotPassword={handleForgotPassword}
        />
        
        <div className="mt-4 text-center">
          <p className="text-sm text-gray-600">
            Don't have an account?{' '}
            <a href="/contactmanager/signup" className="text-blue-500 hover:text-blue-600">
              Sign up for free
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}